export class GetJobProgressStepsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "steps",
            "baseName": "steps",
            "type": "Array<JobProgressStep>",
            "format": ""
        },
        {
            "name": "jobEta",
            "baseName": "jobEta",
            "type": "JobProgressStepEta",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetJobProgressStepsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
